import m from 'mithril'
import moment from 'moment' 
import Kindle from '../shared/kindle.js'
import Cookie from '../shared/cookie.js'

import './ig.css'
var InstagramPhotos = {
  data: [],
  COOKIE: "InstagramAccount",
  prompt: function(reload) {
    var user = Cookie.get(InstagramPhotos.COOKIE) || "peachesvonb";
    user = prompt("What Instagram account would you like to see?", user)
    if (user) {
      Cookie.set(InstagramPhotos.COOKIE, user);
      if (reload) InstagramPhotos.loadList()
    }
    return user;
  },
  loadList: function() {
      var user = Cookie.get(InstagramPhotos.COOKIE);
      if (!user) {
        user = InstagramPhotos.prompt()
      }
      return m.request({
          method: "GET",
          url: "https://www.instagram.com/"+user+"/?__a=1",
      })
      .then(function(result) {
        var user = result.graphql.user;
        var edges = user.edge_owner_to_timeline_media.edges;
        
        var pics = [];
        for (var i = 0; i < edges.length; i++) {

          var node = edges[i].node;
          var edge = node.edge_media_to_caption.edges;
          if (!edge || !edge.length) continue;
          var info = {
            url: node.display_url,
            caption: node.edge_media_to_caption.edges.pop().node.text,
            timestamp: node.taken_at_timestamp,
            location: node.location
          }
          pics.push(info);
        }
      
        InstagramPhotos.data = pics
      })
  },
}

function markHashtags(string) {
  return string.replace(/(#\w+)/g, '<span class="hashtag">$1</span>')
}
var InstagramViewer = {
  index: 0,
  view: function(vnode) {
    var attrs = vnode.attrs;
    var data = InstagramPhotos.data;

    var index = Math.floor(Math.random() * data.length);
    var info = data[index];
    if (!info) {
      return m('div.caption', "Loading Instagram...");
    }
    return m("div.instagram", 
      m("div.image", {
        onclick: function() { InstagramPhotos.prompt(true)},
        style: "width:"+ window.innerWidth+ "px; height:"+ window.innerWidth+ "px; background-image: url(" + info.url + ")"}),
      m("div.caption", m.trust(markHashtags(info.caption))),
      info.location ? m("div.location", info.location.name) : undefined  
    );
  },
  
  oninit: function(vnode) {
    InstagramPhotos.loadList()
    vnode.state.interval = setInterval(m.redraw, 5 * 60 * 1000)
  },

  onremove: function(vnode) {
    clearTimeout(vnode.state.timeout)
  }
}

module.exports = InstagramViewer